// src/context/AuthContext.js

import React, { useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // Finansal verilerin gizliliği için global state
  const [finansGizli, setFinansGizli] = useState(false);

  useEffect(() => {
    // Not: burada eskiden `settings/{uid}` üzerinde sürekli açık bir onSnapshot
    // dinleyicisi vardı; tek amacı `aiAssistantEnabled` alanını currentUser'a
    // eklemekti ve bu alan hiçbir bileşende okunmuyordu (AI asistan modülü yok).
    // Her oturumda gereksiz bir dinleyici + giriş gecikmesi üretiyordu — kaldırıldı.
    // Global `settings/sms` belgesi Ayarlar ekranından okunmaya devam ediyor.
    const authUnsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Kullanıcı girişi var
        const idTokenResult = await user.getIdTokenResult(true);
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);

        const role = idTokenResult.claims.role || (userDoc.exists() ? userDoc.data().role : undefined);

        setCurrentUser({
          ...user,
          role: role,
          claims: idTokenResult.claims
        });
        setLoading(false);
      } else {
        // Kullanıcı çıkışı
        setCurrentUser(null);
        setLoading(false);
      }
    });

    return () => authUnsubscribe();
  }, []);

  const value = {
    currentUser,
    loading,
    finansGizli,
    setFinansGizli,
    toggleFinansGizli: () => setFinansGizli(prev => !prev),
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}